import { FormattedMessage } from 'react-intl';
import { Settings } from '../../pages/Settings';
import { SidebarMenu } from '../SidebarMenu';
import { setSettingsSidebar, useSettingsSidebarOpen } from './service';

export const SettingsSidebar = () => {
  const open = useSettingsSidebarOpen();

  return (
    <SidebarMenu
      open={open}
      onClose={() => setSettingsSidebar(false)}
      header={<FormattedMessage id="Settings" />}
    >
      <Settings />
    </SidebarMenu>
  );
};
